<template>
  <div>
    <div v-if="loaded" class="nav">
      <div class="top clear gray" v-bind:class="'bdg-' + tenant">
        <div class="logo" v-bind:class="'logo-' + tenant"></div>
      </div>
    </div>
    <!--container-->
    <div
      v-if="
        curStatus === 'normal' &&
          loaded &&
          $route.path.split('/')[2] !== 'write' &&
          $route.path.split('/')[2] !== 'selection' &&
          $route.path.split('/')[2] !== 'complete' &&
          construction != true
      "
      :class="{ unfold: unfold }"
      class="head"
    >
      <div class="tit" @click="fold">{{ cur }}</div>
      <ul>
        <li v-for="item in list" :key="item.id" @click="dtl(item.path)">
          <span
            v-bind:class="[tenantClassCur(item.match), tenantClass(item.match)]"
            >{{ item.val }}</span
          >
        </li>
      </ul>
    </div>
    <!--child-->
    <router-view v-if="curStatus === 'normal' && loaded" />
    <!--footer-->
    <div v-if="curStatus === 'normal' && loaded" class="fotWrap">
      <div class="fotCon">
        <div class="top clear">
          <!--logo-->
          <div class="logo" v-bind:class="'logoOnWhite-' + tenant"></div>
          <!--share-->
          <div class="share clear">
            <a
              v-if="socialTwitter != null"
              :href="socialTwitter"
              class="twitter"
              target="_blank"
            ></a>
            <a
              v-if="socialFacebook != null"
              :href="socialFacebook"
              class="facebook"
              target="_blank"
            ></a>
            <a
              v-if="socialInstagram != null"
              :href="socialInstagram"
              class="ins"
              target="_blank"
            ></a>
          </div>
        </div>
        <div class="bottom">
          <p style="padding-bottom:.2rem">
            <router-link tag="strong" to="/term2"
              ><i>Terms & Conditions</i></router-link
            >
            <span>|</span>
            <router-link tag="strong" to="/policy2"
              ><i>Privacy Policy</i></router-link
            >
          </p>
          <p style="text-decoration:none;">
            team@unifiproperty.com COPYRIGHT 2020
          </p>
        </div>
      </div>
    </div>
    <div
      v-if="curStatus === 'delete' && loaded"
      style="padding-top:62px;
font-size: 20px;
font-family: ProximaNova-Regular, ProximaNova;
color: #3F3F46;
line-height: 20px;
text-align:center"
    >
      The sharing link for this property has been closed.
    </div>

    <div v-if="show && loaded" class="loginWrapper">
      <!--background-->
      <div class="innerWrapper">
        <div class="upper">
          <div class="top">
            <div class="logo" v-bind:class="'logo2-' + tenant"></div>
          </div>
        </div>
        <div class="popWrapper" v-bind:class="'tenant-' + tenant">
          <h1 v-bind:class="'tenant-' + tenant">Property is protected</h1>
          <div>
            <div class="inputItem">
              <i class="title">Enter Passphrase</i>
              <input
                v-model="pswd"
                maxlength="12"
                type="password"
                @input="
                  pswd = pswd.replace(/\s+/g, '');
                  if (pswd !== '') disable = false;
                  else disable = true;
                "
                @keyup.13="save"
              />
            </div>
            <button
              :class="{ disabled: disable }"
              :disabled="disable"
              class="colored"
              @click="save"
            >
              Open Property
            </button>
            <p>
              If you don't have the passphrase to unlock this preview, please
              ask the sender to share it with you.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  inject: ["reload"],
  data() {
    return {
      gray: true,
      socialInstagram: "",
      socialTwitter: "",
      socialFacebook: "",
      cur: "Property Details",
      list: [
        {
          path: "/private/property",
          match: "property",
          val: "Property Details",
          id: 0
        },
        {
          path: "/private/plans",
          match: "plans",
          val: "Floor Plans",
          id: 1
        },
        {
          path: "/private/site",
          match: "site",
          val: "Site Plans",
          id: 8
        },
        /*{
            path: '/private/price',
            match: 'price',
            val: 'Pricelist',
            id: 2
        },*/
        {
          path: "/private/specificate",
          match: "specificate",
          val: "Specifications",
          id: 3
        },
        {
          path: "/private/schadule",
          match: "schadule",
          val: "Tax Depreciation Schedule",
          id: 4
        },
        {
          path: "/private/appraisal",
          match: "appraisal",
          val: "Rental Appraisal",
          id: 5
        },
        {
          path: "/private/fee",
          match: "fee",
          val: "Associated Fees",
          id: 6
        },
        {
          path: "/private/looking",
          match: "looking",
          val: "The Why",
          id: 7
        },
        {
          path: "/private/valuation",
          match: "valuation",
          val: "Comparable Sales",
          id: 9
        }
      ],
      current: null,
      showMask: false,
      pm: {},
      hasPrice: false,
      pswd: "",
      disable: true,
      show: true,
      loaded: false,
      construction: false,
      unfold: false,
      tenant: window.location.hostname
        .replace("m.", "")
        .split(".")[0]
        .split("testunifiproperty")[0]
        .split("unifiproperty")[0]
        .split("platform")[0]
    };
  },
  created() {
    var that = this;
    that.getSocial({ callback: that.socialCallback });
    if (!that.$route.params.id) {
      return;
    }
    that.pm = that.$route.params;

    if (this.$route.path.split("/")[2] === "construction") {
      that.construction = true;
    }

    that.getPropertyDtl2({
      params: {
        id: that.$route.params.id,
        password: "",
        publicFlag: this.$route.query.publicFlag ? 1 : 0
      },
      callback: that.rCallback
    });

    if (sessionStorage.getItem("hasPrice") === "1") {
      this.hasPrice = true;
      this.list = [
        {
          path: "/private/property",
          match: "property",
          val: "Property Details",
          id: 0
        },
        {
          path: "/private/plans",
          match: "plans",
          val: "Floor Plans",
          id: 1
        },
        {
          path: "/private/site",
          match: "site",
          val: "Site Plans",
          id: 8
        },
        {
          path: "/private/price",
          match: "price",
          val: "Pricelist",
          id: 2
        },
        {
          path: "/private/specificate",
          match: "specificate",
          val: "Specifications",
          id: 3
        },
        {
          path: "/private/schadule",
          match: "schadule",
          val: "Tax Depreciation Schedule",
          id: 4
        },
        {
          path: "/private/appraisal",
          match: "appraisal",
          val: "Rental Appraisal",
          id: 5
        },
        {
          path: "/private/fee",
          match: "fee",
          val: "Associated Fees",
          id: 6
        },
        {
          path: "/private/looking",
          match: "looking",
          val: "The Why",
          id: 7
        },
        {
          path: "/private/valuation",
          match: "valuation",
          val: "Comparable Sales",
          id: 9
        }
      ];
    }
    that.list.forEach(v => {
      if (v.match === that.$route.path.split("/")[2]) {
        that.cur = v.val;
      }
    });
  },
  computed: {
    ...mapState({
      curStatus: state => state.login.status // 实时变化
    })
  },
  methods: {
    ...mapActions("social", ["getSocial"]),
    // 展开收起
    fold() {
      var that = this;
      that.unfold = !that.unfold;
      console.log(that.unfold);
    },
    ...mapMutations("login", ["changeStatus"]),
    rCallback(res) {
      var that = this;
      if (res.data.code === 400004) {
        this.loaded = true;
        that.show = false;
      } else if (res.data.code === 400005) {
        this.loaded = true;
        that.changeStatus({ data: "normal" });
        if (
          sessionStorage.getItem(that.$route.params.id) &&
          sessionStorage.getItem(that.$route.params.id) === "1"
        ) {
          that.show = false;
        }
      } else {
        this.$box.alert("", res.data.message, "error");
      }
    },
    socialCallback(res) {
      var that = this;
      if (res.data.code == 0) {
        this.socialInstagram = res.data.data.socialInstagram;
        this.socialTwitter = res.data.data.socialTwitter;
        this.socialFacebook = res.data.data.socialFacebook;
      } else if (
        res.data.code == 90000 ||
        res.data.code == 90002 ||
        res.data.code == 90001
      ) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
      that.getUserDtl({ callback: that.userCallback });
    },
    save() {
      var that = this;
      if (that.pswd == "") {
        return;
      }
      if (that.pswd.length < 6 || that.pswd.length > 13) {
        this.$box.alert("", "Please enter a 6-12 digit password", "error");
        return;
      }
      that.$box.loadings();
      that.getPropertyDtl2({
        params: {
          id: that.$route.params.id,
          password: that.pswd,
          publicFlag: this.$route.query.publicFlag ? 1 : 0
        },
        callback: that.callback
      });
    },
    callback(res) {
      this.$box.loadings(2);
      if (res.data.code === 0) {
        this.show = false;
        sessionStorage.removeItem("hasPrice");
        sessionStorage.removeItem(this.$route.params.id);
        // sessionStorage.removeItem('psd')
        sessionStorage.setItem(this.$route.params.id, "1");
        sessionStorage.setItem("psd", this.pswd + "/" + this.$route.params.id);
        if (res.data.data.lineType !== "offline") {
          this.hasPrice = true;
          sessionStorage.setItem("hasPrice", "1");
          this.list = [
            {
              path: "/private/property",
              match: "property",
              val: "Property Details",
              id: 0
            },
            {
              path: "/private/plans",
              match: "plans",
              val: "Floor Plans",
              id: 1
            },
            {
              path: "/private/site",
              match: "site",
              val: "Site Plans",
              id: 8
            },
            {
              path: "/private/price",
              match: "price",
              val: "Pricelist",
              id: 2
            },
            {
              path: "/private/specificate",
              match: "specificate",
              val: "Specifications",
              id: 3
            },
            {
              path: "/private/schadule",
              match: "schadule",
              val: "Tax Depreciation Schedule",
              id: 4
            },
            {
              path: "/private/appraisal",
              match: "appraisal",
              val: "Rental Appraisal",
              id: 5
            },
            {
              path: "/private/fee",
              match: "fee",
              val: "Associated Fees",
              id: 6
            },
            {
              path: "/private/looking",
              match: "looking",
              val: "The Why",
              id: 7
            },
            {
              path: "/private/valuation",
              match: "valuation",
              val: "Comparable Sales",
              id: 9
            }
          ];
        }
        this.reload();
      } else if (res.data.code === 400004) {
        this.$box.alert("", res.data.message, "error");
        sessionStorage.removeItem(this.$route.params.id);
        sessionStorage.removeItem("psd");
      } else {
        this.$box.alert("", res.data.message, "error");
        sessionStorage.removeItem(this.$route.params.id);
        sessionStorage.removeItem("psd");
      }
    },
    hoverEvt(e) {
      this.current = e;
    },
    ...mapActions("property", ["getPropertyDtl2"]),
    outEvt() {
      this.current = null;
    },
    dtl(path) {
      var that = this;
      that.unfold = false;
      if (this.$route.query.publicFlag)
        that.$router.push(
          `${path}/${that.pm.id}?publicFlag=${this.$route.query.publicFlag}&sessionId=${this.$route.query.sessionId}`
        );
      else that.$router.push(`${path}/${that.pm.id}`);
      that.list.forEach(v => {
        if (v.match === that.$route.path.split("/")[2]) {
          that.cur = v.val;
        }
      });
    },
    toPia() {
      var that = this;
      that.$router.push(
        `/index/pia/${that.pm.id}/${that.pm.roomId}/${that.pm.operate}`
      );
    },
    toCus() {
      var that = this;
      that.$router.push({ path: `/pia/selection/${that.pm.id}` });
      that.showMask = false;
    },
    refresh(path) {
      if (path == this.$route.path) {
        location.reload();
      }
    },
    tenantClassCur(match) {
      let className = "";
      if (this.$route.path.split("/")[2] == match) {
        className = "cur";
      }
      return className;
    },
    tenantClass(match) {
      let className = "";
      if (this.$route.path.split("/")[2] == match) {
        className = "tenant-" + this.tenant;
      }
      return className;
    }
  }
};
</script>

<style lang="scss" scoped>
.head {
  width: 100%;
  position: fixed;
  left: 0;
  top: 1.04rem;
  overflow: hidden;
  z-index: 10;
  background: rgba(0, 0, 0, 0.3);
  overflow: hidden;

  .tit {
    height: 1.16rem;
    box-sizing: border-box;
    background: #f5f5f7;
    border-bottom: 1px solid #d0d0d4;
    font-size: 0.32rem;
    text-align: center;
    line-height: 1.16rem;
    color: #3f3f46;
    font-family: ProximaNova-Semibold;
    cursor: pointer;
    position: relative;
  }

  .tit:after {
    content: "";
    display: block;
    width: 0.18rem;
    height: 0.1rem;
    position: absolute;
    right: 0.3rem;
    top: 0.5rem;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
    background-image: url("../../assets/arrw.png");
  }

  ul {
    width: 100%;
    height: 0;
    overflow: hidden;
    background: #f5f5f7;
    transition: all 0.5s;

    li {
      width: 100%;
      text-align: center;
      height: 0.96rem;
      font-size: 0.32rem;
      color: rgba(63, 63, 70, 1);
      line-height: 0.96rem;
    }

    .cur {
      position: relative;
      padding: 0 0.2rem;
    }

    .cur:after {
      content: "";
      display: block;
      width: 100%;
      height: 0.06rem;
      //background: #FFEF00;
      position: absolute;
      left: 0;
      bottom: -0.1rem;
    }
  }
}

.unfold {
  bottom: 0;
  overflow: auto;

  ul {
    height: 10rem;
    transition: all 0.5s;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.nav {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 12;

  .top {
    width: 100%;
    height: 1.04rem;
    transition: all 0.5s;

    .logo {
      //width: 1.4rem;
      //height: .56rem;
      //margin: .24rem 0 .24rem .24rem;
      float: left;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: contain;
      //background-image: url('../../assets/logo.png');
      cursor: pointer;
    }
  }

  //.gray{
  //  background: #3F3F46;
  // }
}

.fotWrap {
  width: 100%;
  background: #f5f5f7;
}

.fotTxt {
  width: 100%;
  height: 5.68rem;
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
  background-image: url("https://s3.ap-southeast-2.amazonaws.com/com.unifiproperty/files/images/202007tswZY21nGL");
  color: #fff;

  h1 {
    font-size: 0.52rem;
    line-height: 0.78rem;
    padding: 0.7rem 1rem 0 1rem;
    margin-bottom: 0.18rem;
    text-align: center;
    word-break: break-word;
  }

  h2 {
    font-size: 0.32rem;
    line-height: 0.48rem;
    margin-bottom: 0.48rem;
    text-align: center;
    padding: 0 0.64rem;
  }

  .link {
    display: block;
    border: none;
    margin: 0 auto;
    cursor: pointer;
    width: 5.18rem;
    height: 0.92rem;
    background: rgba(44, 202, 115, 1);
    border-radius: 6px;
    text-align: center;
    line-height: 0.92rem;
    font-size: 0.28rem;
    color: #fff;
    font-family: ProximaNova-Semibold;
    text-decoration: none;
  }
}

.fotCon {
  width: 100%;
  margin: 0 auto;
  color: #fff;
  padding: 0 0.32rem;
  box-sizing: border-box;

  .top {
    padding: 0.48rem 0;
    border-bottom: 1px solid #3f3f46;
    margin-bottom: 0.32rem;
  }

  .logo {
    //width: 1.72rem;
    //height: 0.68rem;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    //background-image: url('../../assets/footer.png');
    float: left;
    cursor: pointer;
  }

  .share {
    float: right;

    .twitter {
      display: block;
      width: 0.65rem;
      height: 0.65rem;
      background-size: contain;
      background-position: center center;
      background-repeat: no-repeat;
      background-image: url("../../assets/t.png");
      float: right;
      cursor: pointer;
    }

    .ins {
      display: block;
      width: 0.65rem;
      height: 0.65rem;
      background-size: contain;
      background-position: center center;
      background-repeat: no-repeat;
      background-image: url("../../assets/1iocn.png");
      float: left;
      cursor: pointer;
      margin-right: 0.2rem;
    }

    .facebook {
      display: block;
      width: 0.65rem;
      height: 0.65rem;
      background-size: contain;
      background-position: center center;
      background-repeat: no-repeat;
      background-image: url("../../assets/f.png");
      float: right;
      margin-right: 0.2rem;
      cursor: pointer;
    }
  }

  .bottom {
    text-align: center;

    ul {
      display: inline-block;
      font-size: 0.32rem;
      width: 100%;
      color: #111111;
      border-bottom: 1px solid #3f3f46;
      padding-bottom: 0.42rem;
      margin-bottom: 0.52rem;

      li {
        font-size: 0.32rem;
        line-height: 0.38rem;
        margin: 0.28rem 0;
        cursor: pointer;

        a {
          color: #111111;
          text-decoration: none;
        }
      }

      li:nth-last-child(1) {
        margin: 0;
      }
    }

    p {
      padding-bottom: 0.52rem;
      font-size: 0.24rem;
      line-height: 0.28rem;
      color: #3f3f46;
      text-align: center;
      text-decoration: underline;
      cursor: pointer;

      span {
        display: inline-block;
        margin: 0 0.25rem;
        text-decoration: none;
      }

      i {
        font-style: normal;
      }

      strong {
        font-weight: normal;
      }
    }
  }
}

.loginWrapper {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  background-color: #3f3f46;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 12;
  box-sizing: border-box;
  padding: 0.5rem 0.3rem 0.3rem;

  .innerWrapper {
    width: 100%;
    margin: 0 auto;

    .upper {
      margin-bottom: 0.5rem;
    }

    .logo {
      text-align: center;
      margin: 0 auto;

      img {
        display: inline-block;
        width: 40%;
      }
    }
  }

  .popWrapper {
    width: 100%;
    border-radius: 0.03rem;
    margin: 0 auto;
    background: #fff;
    overflow: hidden;
    position: relative;
    padding: 0 0.3rem 0.5rem 0.3rem;
    box-sizing: border-box;

    h1 {
      margin: 0.6rem auto;
      line-height: 0.4rem;
      font-size: 0.4rem;
      color: #3f3f46;
      text-align: center;
      position: relative;
    }

    h1:after {
      content: "";
      position: absolute;
      left: 20%;
      top: 0.5rem;
      width: 0.7rem;
      height: 3px;
      //background: #FFEF00;
    }

    .inputItem {
      width: 100%;
      margin: 0.3rem auto 0.5rem auto;
      position: relative;

      .title {
        display: block;
        font-style: normal;
        color: #908d90;
        font-size: 0.3rem;
        margin-bottom: 0.2rem;
      }

      input {
        width: 100%;
        height: 0.8rem;
        border-radius: 0.06rem;
        border: 1px solid #e0dde0;
        outline: none;
        transition: all 0.5s;
        box-sizing: border-box;
        padding-left: 0.2rem;
      }
    }

    .colored {
      display: block;
      width: 100%;
      height: 0.8rem;
      margin: 0 auto 0.4rem auto;
      background: #2cca73;
      border: none;
      border-radius: 0.06rem;
      font-size: 0.3rem;
      text-align: center;
      line-height: 0.8rem;
      cursor: pointer;
      color: #fff;
      transition: all 0.3s;
      font-family: ProximaNova-Semibold;
    }

    .disabled {
      background: #a1e4bf;
      cursor: not-allowed;
    }

    p {
      font-size: 0.3rem;
      font-family: ProximaNova-Regular, ProximaNova;
      font-weight: 400;
      color: #3f3f46;
      line-height: 0.5rem;
      text-align: center;
      width: 100%;
      margin: 0 auto;
    }
  }

  .popWrapper:after {
    content: "";
    width: 100%;
    height: 10px;
    position: absolute;
    left: 0;
    top: 0;
    //background: #FFEF00;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/private/index.vue